import Select from "@8x8/oxygen-select";
import { useGetUsersQuery } from "./api";
import { useMemo } from "react";
import Tooltip from "@8x8/oxygen-tooltip";

export const userSelectorValue = (user) =>
  `${user?.firstName} ${user?.lastName} ${user?.primaryEmail} ${user?.loginId}`;

const AdminSearch = ({ onChange, currentUser }) => {
  const { data, isFetching } = useGetUsersQuery();

  const options = useMemo(
    () =>
      data?.map((user) => ({
        user: user,
        label: (
          <Tooltip key={user?.userId} title={`Login ID: ${user?.loginId}`}>
            <div data-testid={"admin-search__option-label"}>
              {user?.firstName} {user?.lastName}, {user.primaryEmail}
            </div>
          </Tooltip>
        ),
        value: userSelectorValue(user),
      })),
    [data]
  );

  const selectedValue = options?.find(
    (option) => option.user?.userId === currentUser?.userId
  );

  return (
    <Select
      options={options}
      value={selectedValue}
      placeholder={"Select primary admin"}
      isClearable={true}
      onChange={(opt) => onChange(opt.user)}
      isLoading={isFetching}
    />
  );
};

export default AdminSearch;
